export interface SightModalCity {
  name_ru: string;
  slug?: string;
}

export interface SightModalSight {
  id: number;
  name: string;
  slug?: string;
  description?: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  excursions_count?: number;
  tag_id?: number;
  experience_main_photo_url?: string;
}

export interface SightModalNav {
  info: boolean;
  position: boolean;
  guides: boolean;
  experience: boolean;
}

export const defaultSightModalNav = (): SightModalNav => ({
  info: true,
  position: true,
  guides: false,
  experience: false,
});

export interface SightGuideInfo {
  id?: number;
  first_name?: string;
  determination?: string;
  exp_count?: number;
  rating?: number;
  avatar_url?: string;
}

export interface SightGuideComment {
  id: number;
  text?: string;
  guide?: SightGuideInfo;
}
